<template>
  <div class="settings__notification">
    <div
      v-for="(notificationTypeValue,
      notificationTypeName,
      index) in notifications"
      :key="index"
    >
      <div class="d-flex align-center">
        <h4>{{ notificationTypeName | capitalize }}</h4>
        <v-divider inset />
      </div>
      <div class="settings__notification--items">
        <div
          class="settings__notification--item"
          v-for="(setting, name, index) in notificationTypeValue"
          :key="index"
        >
          <p>{{ getNotificationParams(notificationTypeName, name).label }}</p>
          <v-switch
            :aria-label="
              `switch ${
                getNotificationParams(notificationTypeName, name).label
              }`
            "
            :readonly="!canEditNotification(notificationTypeName, name)"
            :input-value="notificationTypeValue[name]"
            @change="val => editNotification(notificationTypeName, name, val)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import getNotificationParams from "../modules/getNotificationParams";
import { isPermissioned } from "@/utils/permissions";

export default {
  props: {
    initialNotifications: {
      type: Object,
      required: true
    }
  },
  created() {
    this.notifications = cloneDeep(this.initialNotifications);
  },
  data() {
    return {
      notifications: []
    };
  },
  methods: {
    editNotification(notificationType, notificationName, value) {
      const notificationData = {
        key: `notifications.emails.${notificationType}.${notificationName}`,
        value
      };
      this.$emit("editNotification", notificationData);
    },
    getNotificationParams,
    canEditNotification(notificationTypeName, name) {
      const { permission } = getNotificationParams(notificationTypeName, name);
      return (
        isPermissioned("settings.edit-notifications") &&
        isPermissioned(`settings.edit-notifications.${permission}`)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.settings__notification {
  margin-top: 50px;
  padding-left: 0px !important;

  hr.v-divider.v-divider--inset.theme--light {
    margin-bottom: 0;
    margin-left: 100px;
  }

  &--items {
    padding: 20px 0;
  }

  &--item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;

    .v-input--selection-controls {
      margin-top: 0px;
      padding-top: 0px;
    }
  }
}
</style>
